import { observer } from 'mobx-react';
import React, { FC, useCallback } from 'react';

import { OrderPageStore } from 'app/logic/pages/order/OrderPageStore';

import { LatinFormItem } from './LatinFormItem';

export interface NameEngFormItemProps {
    /**
     * Стор страницы.
     */
    pageStore: OrderPageStore;
}

export const SurnameEngFormItem: FC<NameEngFormItemProps> = observer(
    ({ pageStore }) => {
        const onChangeHandler = useCallback(
            (nameLatin: string) =>
                pageStore.orderFormStore.setSurnameLatin(nameLatin),
            [pageStore.orderFormStore],
        );

        return (
            <LatinFormItem
                defaultValue={
                    pageStore.orderFormStore.surnameLatin?.toUpperCase() ?? ''
                }
                placeholder={'Фамилия латиницей'}
                formItemName={'surnameLatin'}
                onChangeFormItemValue={onChangeHandler}
            />
        );
    },
);
